import MilitaryInstallation from './MilitaryInstallation';

export default MilitaryInstallation;
